<button
  class="btn btn-success btn-sm merge-btn" (click)="openMergeOrdersModal()"
  title="Gộp với {{mergeSuggestions.length}} đơn hàng tương tự">
  <i class="fas fa-link"></i> Gộp Đơn
</button>

<ng-template #mergeOrdersModal let-modal>
  <div class="modal-lg">
    <div class="modal-header">
      <h4 class="modal-title">Gộp Đơn Hàng</h4>
      <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <!-- Left side - Origin order info -->
        <div class="col-6" style="border-right: 1px solid #dee2e6; padding-right: 20px; padding-top: 160px">
          <h5 class="text-primary mb-3">Đơn hàng gốc</h5>
          <div class="order-info">
            <div class="mb-2">
              <strong>Mã đơn:</strong> {{saleRecord.sourceOrderId}}
            </div>
            <div class="mb-2">
              <strong>Khách hàng:</strong> {{saleRecord.customerName}}
            </div>
            <div class="mb-2">
              <strong>Địa chỉ:</strong>
              <div class="address-details">
                <div *ngIf="saleRecord.streetAddress">{{saleRecord.streetAddress}}</div>
                <div *ngIf="saleRecord.streetAddress2">{{saleRecord.streetAddress2}}</div>
                <div *ngIf="saleRecord.city">{{saleRecord.city}}</div>
                <div *ngIf="saleRecord.state">{{saleRecord.state}}</div>
                <div *ngIf="saleRecord.zipCode">{{saleRecord.zipCode}}</div>
                <div *ngIf="saleRecord.channel">{{saleRecord.channel}}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right side - Search and target order -->
        <div class="col-6" style="padding-left: 20px;">
          <!-- Search section -->
          <h5 class="text-success mb-3">
            {{selectedOrderToMerge ? 'Tìm kiếm đơn hàng khác' : 'Chọn đơn hàng để gộp'}}
            <span *ngIf="mergeSuggestions && mergeSuggestions.length > 0" class="badge badge-info ml-2">
              {{mergeSuggestions.length}} gợi ý
            </span>
          </h5>
          <div class="form-group">
            <label>Tìm kiếm và chọn đơn hàng:</label>
            <ng-select 
              [items]="availableOrders"
              bindLabel="displayText"
              bindValue="orderItemId"
              placeholder="Nhập tên khách hàng hoặc mã đơn để tìm kiếm..."
              (change)="onOrderSelected($event)"
              [clearable]="true"
              [searchable]="true"
              [loading]="isLoading"
              (search)="onSearchInput($event)"
              [notFoundText]="'Không tìm thấy đơn hàng nào'"
              [addTag]="false"
              [closeOnSelect]="true">
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div class="order-option">
                  <div class="order-id"><strong>Mã đơn: {{item.sourceOrderId}}</strong></div>
                  <div class="customer-name"><strong>Khách hàng:</strong> {{item.customerName}}</div>
                  <div class="customer-address"><strong>Địa chỉ:</strong> {{getCustomerAddress(item)}}</div>
                </div>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span *ngIf="item">{{item.sourceOrderId}} - {{item.customerName}}</span>
              </ng-template>
            </ng-select>
            
            <small class="form-text text-muted">
              <span *ngIf="mergeSuggestions && mergeSuggestions.length > 0">
                Lọc trong {{mergeSuggestions.length}} đơn hàng gợi ý hoặc tìm kiếm theo tên khách hàng
              </span>
              <span *ngIf="!mergeSuggestions || mergeSuggestions.length === 0">
                Tìm kiếm theo tên khách hàng hoặc mã đơn hàng nguồn
              </span>
            </small>
          </div>

          <!-- Target order info - shown when order is selected -->
          <div *ngIf="selectedOrderToMerge" class="mt-4">
            <h5 class="text-success mb-3">Đơn hàng đích</h5>
            <div class="order-info">
              <div class="mb-2">
                <strong>Mã đơn:</strong> {{selectedOrderToMerge.sourceOrderId}}
              </div>
              <div class="mb-2">
                <strong>Khách hàng:</strong> {{selectedOrderToMerge.customerName}}
              </div>
              <div class="mb-2">
                <strong>Địa chỉ:</strong>
                <div class="address-details">
                  <div *ngIf="selectedOrderToMerge.customerAddress.streetAddress">{{selectedOrderToMerge.customerAddress.streetAddress}}</div>
                  <div *ngIf="selectedOrderToMerge.customerAddress.streetAddress2">{{selectedOrderToMerge.customerAddress.streetAddress2}}</div>
                  <div *ngIf="selectedOrderToMerge.customerAddress.city">{{selectedOrderToMerge.customerAddress.city}}</div>
                  <div *ngIf="selectedOrderToMerge.customerAddress.state">{{selectedOrderToMerge.customerAddress.state}}</div>
                  <div *ngIf="selectedOrderToMerge.customerAddress.zipCode">{{selectedOrderToMerge.customerAddress.zipCode}}</div>
                  <div *ngIf="selectedOrderToMerge.customerAddress.channel">{{selectedOrderToMerge.customerAddress.channel}}</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeModal()">Hủy</button>
      <button type="button" class="btn btn-success" (click)="confirmMerge()" [disabled]="!selectedOrderToMerge">
        <i class="fas fa-link"></i> Gộp Đơn
      </button>
    </div>
  </div>
</ng-template>
